import { useLocale } from "../../i18n";
import { Transaction, TransactionType } from "./useTransactions";

const hasPlusSymbol = [
  TransactionType.ACCUMULATION,
  TransactionType.ALLOWANCE_DELIVERY,
  TransactionType.REFUND,
];

const useTransactionAmount = ({
  amount,
  type,
}: Pick<Transaction, "amount" | "type">) => {
  const locale = useLocale();

  return `${hasPlusSymbol.includes(type) ? "+" : "-"}${amount.toFormatString(
    locale
  )}`;
};

export { useTransactionAmount };
